import { checkExists, getUserURL } from '../../../api/commonHTTP';
import { scrollToElement } from '../../../utils/eventUtils';
import { MIN_PHONE } from '../../../utils/formValidation/commonConstants';
import {
    getCharMinMessage,
    getExistsMessage,
    getFormatMessage,
    getReqMessage
} from '../../../utils/formValidation/errorMessageFunctions';
import { validateEmail } from '../../../utils/formValidation/validationFunctions';
import { regExps } from '../../../utils/formValidation/validationPatterns';
import { validateUserTypes } from '../userValidationFunctions';

const MIN_NAME_CHAR = 1;
const MAX_NAME_CHAR = 100;

export const PAYROLL_MAX = `Payroll must be ${MAX_NAME_CHAR} characters or less`;
export const FIRST_NAME_MIN = `First name must be at least ${MIN_NAME_CHAR} character`;
export const FIRST_NAME_MAX = `First name must be ${MAX_NAME_CHAR} characters or less`;
export const FIRST_NAME_FORMAT = `First name must be in the correct format`;
export const LAST_NAME_MIN = `Last name must be at least ${MIN_NAME_CHAR} character`;
export const LAST_NAME_MAX = `Last name must be ${MAX_NAME_CHAR} characters or less`;

export const LAST_NAME_FORMAT = `Last name must be in the correct format`;
export const EMAIL_EXISTS = getExistsMessage('A user with that email address');
export const JOB_TITLE_MAX = `Last name must be ${MAX_NAME_CHAR} characters or less`;
export const NO_CONTRACT_ID = `Please select at least one contract`;
export const NO_SERVICE_ID = 'Please select a primary service';
export const NO_TEAM_ID = 'Please select a primary team';
export const PHONE_MIN = getCharMinMessage('Phone number', MIN_PHONE);
export const PHONE_FORMAT = getFormatMessage('Phone number');
export const NO_ACTIVE = 'Please set the active switch';

export const initialErrorState = {
    loginEmailAddress: { error: false, message: '' },
    communicationEmailAddress: { error: false, message: '' },
    payroll: { error: false, message: '' },
    firstName: { error: false, message: '' },
    lastName: { error: false, message: '' },
    jobTitle: { error: false, message: '' },
    phoneNumber: { error: false, message: '' },
    primaryServiceId: { error: false, message: '' },
    primaryTeamId: { error: false, message: '' },
    contractIds: { error: false, message: '' },
    userTypeIds: { error: false, message: '' },
    active: { error: false, message: '' }
};

export const validate = (newEntry, userTypes) => {
    let newErrors = {};

    if (newEntry.payroll?.trim().length > MAX_NAME_CHAR) {
        newErrors = {
            ...newErrors,
            payroll: { error: true, message: PAYROLL_MAX }
        };
    }

    if (newEntry.firstName?.trim().length < MIN_NAME_CHAR) {
        newErrors = {
            ...newErrors,
            firstName: { error: true, message: FIRST_NAME_MIN }
        };
    } else if (newEntry.firstName?.trim().length > MAX_NAME_CHAR) {
        newErrors = {
            ...newErrors,
            firstName: { error: true, message: FIRST_NAME_MAX }
        };
    } else if (!regExps.NAME_R.test(newEntry.firstName)) {
        newErrors = {
            ...newErrors,
            firstName: { error: true, message: FIRST_NAME_FORMAT }
        };
    }

    if (newEntry.lastName?.trim().length < MIN_NAME_CHAR) {
        newErrors = {
            ...newErrors,
            lastName: { error: true, message: LAST_NAME_MIN }
        };
    } else if (newEntry.lastName?.trim().length > MAX_NAME_CHAR) {
        newErrors = {
            ...newErrors,
            lastName: { error: true, message: LAST_NAME_MAX }
        };
    } else if (!regExps.LAST_NAME_R.test(newEntry.lastName)) {
        newErrors = {
            ...newErrors,
            lastName: { error: true, message: LAST_NAME_FORMAT }
        };
    }

    if (newEntry.jobTitle?.trim().length > MAX_NAME_CHAR) {
        newErrors = {
            ...newErrors,
            jobTitle: { error: true, message: JOB_TITLE_MAX }
        };
    }

    if (newEntry.phoneNumber) {
        if (newEntry.phoneNumber?.trim().length < MIN_PHONE) {
            newErrors = {
                ...newErrors,
                phoneNumber: { error: true, message: PHONE_MIN }
            };
        } else if (!regExps.PHONE_R.test(newEntry.phoneNumber)) {
            newErrors = {
                ...newErrors,
                phoneNumber: { error: true, message: PHONE_FORMAT }
            };
        }
    }

    if (newEntry.contractIds.length < 1) {
        newErrors = {
            ...newErrors,
            contractIds: { error: true, message: NO_CONTRACT_ID }
        };
    }

    if (!newEntry.primaryServiceId) {
        newErrors = {
            ...newErrors,
            primaryServiceId: { error: true, message: NO_SERVICE_ID }
        };
    }

    if (!newEntry.primaryTeamId) {
        newErrors = {
            ...newErrors,
            primaryTeamId: { error: true, message: NO_TEAM_ID }
        };
    }

    newErrors = validateUserTypes(newEntry.userTypeIds, newErrors, userTypes);

    if (newEntry.active == null) {
        newErrors = {
            ...newErrors,
            active: { error: true, message: NO_ACTIVE }
        };
    }

    if (!newEntry.loginEmailAddress) {
        newErrors = {
            ...newErrors,
            loginEmailAddress: { error: true, message: getReqMessage('Login Email') }
        };
    }
    newErrors = validateEmail(newEntry.loginEmailAddress, newErrors, 'loginEmailAddress');

    if (!newEntry.communicationEmailAddress) {
        newErrors = {
            ...newErrors,
            communicationEmailAddress: {
                error: true,
                message: getReqMessage('Communication Email')
            }
        };
    }
    newErrors = validateEmail(
        newEntry.communicationEmailAddress,
        newErrors,
        'communicationEmailAddress'
    );

    scrollToElement(newErrors);
    return newErrors;
};

export const checkEmailAddress = async (emailAddress) => {
    return await checkExists(getUserURL() + `rest/user/exists/email-address/${emailAddress}`).then(
        (ret) => ret
    );
};
